export const defaultTabSlug = "tab";

export function getTabQueryParam(tabTitle: string, tabIndex: number, tabsSlug?: string | null) {
  return { key: tabsSlug ?? defaultTabSlug, value: `${tabTitle}-${tabIndex}` };
}
